import htmr from "htmr";
import React from "react";

export default function (dependencies) {
    class Whatisthis extends React.Component {
        constructor() {
            super()
            this.state = {
                whatIsThisExpanded: false
            }
        }

        toggleWhatIsThis(e) {
            e.preventDefault()

            this.state.whatIsThisExpanded = !this.state.whatIsThisExpanded

            this.forceUpdate()
        }

        getTitle() {
            const { title } = this.props.field.config
            if (typeof title === 'undefined') {
                return 'Hva betyr dette?'
            } 
            else {
                return title
            }
        }

        render() {
            const { text } = this.props.field.config
            if (typeof text !== 'undefined') {
                if (this.state.whatIsThisExpanded === false) {
                    return (
                        <div className="lz-input-wrapper" style={{ marginTop: -10 + 'px' }}>
                            <div onClick={e => this.toggleWhatIsThis(e)} className="lz-whatsthis"><p>{this.getTitle()} <i className="fa fa-angle-down" aria-hidden="true"></i></p></div>
                            <div className="lz-thisiswhat"><p>{htmr(text)}</p></div>
                        </div>
                    )
                }
                else {
                    return (
                        <div className="lz-input-wrapper" style={{ marginTop: -10 + 'px' }}>
                            <div onClick={e => this.toggleWhatIsThis(e)} className="lz-whatsthis"><p>{this.getTitle()} <i className="fa fa-angle-up" aria-hidden="true"></i></p></div>
                            <div className="lz-thisiswhat lz-visible"><p>{htmr(text)}</p></div>
                        </div>
                    )
                }
            }
        }

    }

    return {
        html: Whatisthis
    };
};
